<i class="fa fa-fw" [class.fa-square-o]="!selected" [class.fa-check-square-o]="selected"></i>
